// Thai-locale formatting helpers. Dates render in Buddhist-era short form.

export function thaiDate(value, short = false) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('th-TH', short
    ? { month: 'short', year: '2-digit' }
    : { day: 'numeric', month: 'short', year: '2-digit' });
}

// tenure_days from v_employee_summary is a Postgres interval-as-days integer.
export function tenureLabel(days) {
  if (days == null) return '—';
  const years = Math.floor(days / 365);
  const months = Math.floor((days % 365) / 30);
  const parts = [];
  if (years) parts.push(`${years} ปี`);
  if (months) parts.push(`${months} เดือน`);
  if (!parts.length) parts.push(`${days} วัน`);
  return parts.join(' ');
}
